<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <div
      v-if="mobile && !isClick && value"
      @click="handelClick"
      class="hasvalue"
    >
      <span>{{ value }}</span>
    </div>
    <el-tooltip
      :disabled="disabledTooltip() || !isedite"
      :content="tooltip"
      placement="top-start"
      v-else
    >
      <el-select
        :disabled="!isedite"
        :style="inputStyle"
        v-model="val"
        :filterable="options.length > 10"
        ref="component"
        :placeholder="lagplaceholder"
        @change="handleChange"
        popper-class="sel"
        :loading="listloading"
        @focus="handelfocus"
      >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="
            item['商品']
              ? onegoods.xGoodsId
                ? item['商品']
                : item['商品'] + '(' + item['余量'] + ')'
              : ''
          "
          :value="item['商品']"
          :disabled="(onegoods.xGoodsId && item.id == -1) || item['余量'] == 0"
        />
      </el-select>
    </el-tooltip>
  </div>
</template>

<script>
import _ from 'lodash'
import * as constants from '@/constants'
import * as storage from '@/utils/storage'
import PageModel from '../../models/page'

export default {
  name: 'jtLimitSingle',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    value: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    compWidth: {
      type: String,
      default: '100%',
    },

    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    alwaysEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: String,
      default: '',
    },
    colId: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: '',
    },
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      val: this.value == '' ? null : this.value,
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      listloading: false,
      options: [],
      orderId: '',
      inputStyle: {
        width: window.innerWidth > 768 ? this.compWidth : '100%',
      },
      hasFiredEnterEventHandler: false,
      lagplaceholder:
        storage.getItem(constants.LANGUAGE) === '英文'
          ? 'SELECT'
          : storage.getItem(constants.LANGUAGE) === '中英文'
          ? '请选择/SELECT'
          : '请选择',
      isClick: false,
      onegoods: {},
      oldValue: '',
    }
  },
  watch: {
    value(newValue) {
      this.val = newValue
    },
  },
  computed: {
    isedite() {
      if (this.alwaysEdit) {
        return true
      } else {
        return this.editable
      }
    },
  },
  methods: {
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    async handelfocus() {
      this.listloading = true
      let colId = this.colId
      let rowId = this.rowId
      let tag = this.tag
      let data = await PageModel.getGoodsList(tag, colId, rowId)
      let goodsList = data.goodsList
      if (tag.indexOf('-') > -1) {
        let onegoods = goodsList[0]
        let yuliang = onegoods['余量']
        let arr = [
          {
            id: -1,
            xGoodsId: 0,
            商品: onegoods['商品'] + '(' + onegoods['余量'] + ')',
            余量: -1,
          },
          { id: 0, xGoodsId: 0, 商品: '', 余量: -1 },
        ]
        for (let index = 0; index < yuliang; index++) {
          arr.push({
            id: index + 1,
            xGoodsId: onegoods.xGoodsId,
            商品: index + 1,
            余量: yuliang,
          })
        }
        this.onegoods = onegoods
        this.options = arr
        this.listloading = false
        this.orderId = data.xOldOrderId || 0
        this.oldValue = this.val
      } else {
        goodsList.push({ id: 0, xGoodsId: 0, 商品: '', 余量: -1 })
        this.options = goodsList
        this.listloading = false
        this.orderId = data.xOldOrderId || 0
      }
    },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },
    // handleVisibleChange(visible) {
    //   if (!visible) {
    //     this.$emit('enter')
    //     _.delay(() => this.$emit('datas', null, this.val), 300)
    //   }
    // },
    async handleChange() {
      // this.$emit('enter')
      _.delay(() => this.$emit('datas', null, this.val), 500)
      let obj = _.find(this.options, (item) => item['商品'] == this.val)
      let xOldOrderId = this.orderId
      let colId = this.colId
      let rowId = this.rowId
      let athlete = this.rowId
      if (this.onegoods.xGoodsId) {
        if (this.oldValue) {
          await PageModel.orderGoods(
            xOldOrderId,
            0,
            athlete,
            this.oldValue,
            colId,
            rowId
          )
        }
        if (obj['商品']) {
          _.delay(async () => {
            await PageModel.orderGoods(
              0,
              this.onegoods.xGoodsId,
              athlete,
              obj['商品'],
              colId,
              rowId
            )
          }, 300)
        }
      } else {
        let qty = 1
        let xGoodsId = obj.xGoodsId
        let data = await PageModel.orderGoods(
          xOldOrderId,
          xGoodsId,
          athlete,
          qty,
          colId,
          rowId
        )
      }
      this.isClick = false
    },

    handelClick() {
      this.isClick = true
    },
  },
}
</script>

<style lang="stylus" scoped>
.sel {
  .el-select-dropdown__wrap {
    max-height: 474px;
  }

  .el-select-dropdown__item.hover {
    background-color: #8cc5ff;
  }
}

.hasvalue {
  border: 1px solid #DCDFE6;
  padding: 5px 15px;
  width: 100%;
}
</style>
    